import React, { PropTypes } from 'react';
import styled from 'styled-components';
import { media } from '../../../utils/style-utils';

import ManageImage from '../../../assets/images/login/DataManagement_Image.svg';
import ManageIcon from '../../../assets/images/login/DataManagement_Icon.svg';
import RecordsImage from '../../../assets/images/login/DriverRecords_Image.svg';
import RecordsIcon from '../../../assets/images/login/DriverRecords_Icon.svg';
import CostsImage from '../../../assets/images/login/SaveOnCosts_Image.svg';
import CostsIcon from '../../../assets/images/login/SaveOnCosts_Icon.svg';

const WhyNitroCaption = styled.p`
  color: #303d58;
  text-align: center;
  font-family: ${props => props.theme.font.bold};
  font-size: 24px;
  padding: 40px 0;
  margin: 0;
`;

const Row = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const CenterRow = styled(Row)`
  padding: 120px 0;

  ${media.mobile`
    flex-direction: column-reverse;
    align-items: center;
  `};
`;

const Column = styled.div`
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  max-width: 424px;
  min-width: 329px;
  align-items: start;
  justify-content: center;
  margin-bottom: 20px;
`;

const ReasonImage = styled.img`
  object-fit: contain;
  width: 100%;
`;

const Header = styled.span`
  color: #3f3f3f;
  font-size: 24px;
  margin: 28px 0 14px;
`;

const Body = styled.span`
  color: #616161;
`;

const ParallelogramContainer = styled.div`
  position: relative;
`;

const Parallelogram = styled.div`
  position: absolute;
  z-index: -1;
  transform: skew(0, 14deg);
  background: #fafafa;
  width: 100%;
  height: 100%;
  top: 0;
`;

class LoginWhyNitro extends React.Component {
  render() {
    return (
      <div id={this.props.id}>
        <WhyNitroCaption>Why Nitro?</WhyNitroCaption>
        <Row>
          <Column>
            <img src={RecordsIcon} alt="Manage Fleet and driver records" />
            <Header>
              Manage all your fleet and driver records in one place
            </Header>
            <Body>
              Nitro is a fleet management system that will give you a holistic
              view of your vehicle and driver records.
            </Body>
          </Column>
          <Column>
            <ReasonImage
              src={RecordsImage}
              alt="Manage Fleet and driver records"
            />
          </Column>
        </Row>
        <ParallelogramContainer>
          <Parallelogram />
          <CenterRow>
            <Column>
              <ReasonImage
                src={ManageImage}
                alt="Data management capabilities"
              />
            </Column>
            <Column>
              <img src={ManageIcon} alt="Data management capabilities" />
              <Header>Superior data management capabilities</Header>
              <Body>
                Using cutting edge technology, Nitro is the ultimate and secure
                solution to managing all fleet related data.
              </Body>
            </Column>
          </CenterRow>
        </ParallelogramContainer>
        <Row>
          <Column>
            <img src={CostsIcon} alt="Stay on top of your costs" />
            <Header>Stay on top of your costs</Header>
            <Body>
              Nitro’s reporting suite was built and designed to assist you in
              managing fleet costs. This includes infringement, service and
              maintenance, registration and all other types of costs.
            </Body>
          </Column>
          <Column>
            <ReasonImage src={CostsImage} alt="Stay on top of your costs" />
          </Column>
        </Row>
      </div>
    );
  }
}

LoginWhyNitro.propTypes = {
  id: PropTypes.string,
};

export default LoginWhyNitro;



// WEBPACK FOOTER //
// ./src/features/login/login-why-nitro/LoginWhyNitro.js